import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/CloseSharp';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

const ConfirmationPopup = (props) => {
  const {title,children,openPopup, setClosePopup,successCallbackFn,type,customClass} = props;
    return (
      <Dialog className={`custom-popup confirm-popup ${customClass}`} open={openPopup} >
     <DialogTitle className='custom-header'><span className="title">{title} </span> 
        <IconButton onClick={setClosePopup} aria-label="Close">
        <DeleteIcon />
      </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
        {children}
        {type === "edit-confirmation" &&
        <Box className="custom-footer">
        <Button variant="outlined" className="btn-danger" onClick={setClosePopup}>Cancel</Button>
        <Button className="btn-secondary" variant="contained" onClick={successCallbackFn}>Ok</Button>
        </Box>
        }
         {type === "reviewal-confirmation" &&
        <Box className="custom-footer">
        <Button className="btn-secondary" variant="contained" onClick={successCallbackFn}>To Homescreen</Button>
        </Box>
        }
        </DialogContentText>
        </DialogContent>
    
    </Dialog>
      );
}

export default ConfirmationPopup;
